import React, { useEffect, useState } from 'react';
import { scrollToTop, getItemSession } from '../utils';
import { fetchClient } from '../services/client-api';
import { useLanguage } from '../LanguageContext';
import PoliticsES from '../components/Politics/PoliticsES';
import PoliticsEN from '../components/Politics/PoliticsEN';

const Politics = () => {
    const [client, setClient] = useState([]);
    const { translations, language } = useLanguage();

    useEffect(() => {
        scrollToTop();
    }, []);
    
    const getDados = getItemSession('_dados');
    const dados = JSON.parse(getDados);

    useEffect(() => {
        fetchClient(dados.idCliente)
            .then(result => {
                setClient(result.data.Data.Dados[0])
            });
    }, []);

    return (
        <>
            {language === "es-MX" ? <PoliticsES /> : <PoliticsEN />}
        </>
    );
};

export default Politics;